import { useState } from 'react';

import { useSupportedVideoMimeType } from '#src/app/shared/hooks/media';

type MediaRecorderListeners = {
	onstart: () => void;
	onstop: (blob: Blob) => void;
};

export function useMediaRecorder() {
	const [recorder, setRecorder] = useState<MediaRecorder | null>(null);
	let chunks: BlobPart[];

	const mimeType = useSupportedVideoMimeType();

	const startMediaRecorder = (stream: MediaStream, { onstart, onstop }: MediaRecorderListeners) => {
		const mediaRecorder = new MediaRecorder(stream, { mimeType });
		setRecorder(mediaRecorder);
		// eslint-disable-next-line react-hooks/immutability
		chunks = [];

		mediaRecorder.onstart = () => onstart();
		mediaRecorder.ondataavailable = (e) => {
			chunks.push(e.data);
		};
		mediaRecorder.onstop = () => {
			onstop(new Blob(chunks, { type: mimeType }));
		};
		mediaRecorder.start();
	};

	const stopMediaRecorder = () => {
		// `stop()` throws `InvalidStateError` on a recorder that is already inactive, and stop requests can
		// arrive more than once: `onstop` is asynchronous, so a second trigger (the duration cutoff and the
		// page being hidden, say) can land before the first has finished tearing down.
		if (recorder && recorder.state !== 'inactive') {
			recorder.stop();
		}
	};

	return {
		startMediaRecorder,
		stopMediaRecorder,
	};
}
